import Mutations from '../../odata/mutations';

export default { ...new Mutations('purchaseOrderLine'), ...new Mutations('purchaseOrderLines') };
